module.exports = __webpack_public_path__ + "static/media/story-3.5a0af6a3.jpg";